import { useEffect, useState } from "react";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../common/constant";

export const useFetchDropdown = () => {
  const [dropdownValues, setDropdownValues] = useState({
    terms: [],
    academic_careers: [],
  });

  useEffect(() => {
    const fetchStaticDropdowns = async () => {
      try {
        const [terms, academic_careers] = await Promise.all([
          dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "id"),
          dropdownMapping(
            endpoint.academic_career.getAllActive,
            "academicCareerDispValue", "id"),
        ]);

        setDropdownValues((prev) => ({
          ...prev,
          terms,
          academic_careers,
        }));
      } catch (err) {
        console.error("Failed to fetch dropdowns:", err);
      }
    };

    fetchStaticDropdowns();
  }, []);



  return dropdownValues;
};
